/* import __COLOCATED_TEMPLATE__ from './icon-notes.hbs'; */
import SvgIcon from './svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--notes'],
  width: 18,
  height: 18,
  viewBox: '0 0 24 24'
});